export enum WebhookActionTypes {
  CHANGE_WEBHOOK_DEFINITIONS = 'CHANGE_WEBHOOK_DEFINITIONS',
  CHANGE_WEBHOOK_VALUES = 'CHANGE_WEBHOOK_VALUES',
  CHANGE_CHECK_IS_PRODUCTION_ENABLED = 'CHANGE_CHECK_IS_PRODUCTION_ENABLED',
  CHANGE_WEBHOOK_VALUES_FOR_PRODUCTION = 'CHANGE_WEBHOOK_VALUES_FOR_PRODUCTION',
}
